import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { Box, Checkbox, Grid, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import FormHeader from './form-items/FormHeader';

const useStyles = makeStyles()((theme) =>
({
  root: {},
  checkContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  checkSideWord: {
    flex: 1,
    '& .MuiTypography-root': {
      paddingBottom: theme.spacing(1),
    },
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  checkbox: {
    padding: 5,
    paddingLeft: 0,
    [theme.breakpoints.down('md')]: {
      paddingTop: 3,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 2,
    },
  },
  errorText: {
    color: theme.color.state.stateError,
    marginBottom: theme.spacing(6),
  },
}));

export interface AcknowledgementProps {
  title?: string;
  noTitle?: boolean;
  content?: string;
  isAgreed: boolean;
  handleAgreement: () => void;
  showError: boolean;
}

const Acknowledgement: React.FC<AcknowledgementProps> = (props: AcknowledgementProps) => {
  const {
    title = 'Acknowledgement',
    noTitle,
    content = '',
    isAgreed = false,
    handleAgreement = () => null,
    showError,
  } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();

  const onAgreed = () => {
    handleAgreement();
  };

  return (
    <Grid container className={classes.root} justify="flex-start">
      {!noTitle && <FormHeader title={title} />}
      <Grid container md={12} direction="row">
        <Grid xs={12} className={classes.checkContainer}>
          <Checkbox
            id="checkbox-acknowledgement"
            className={classes.checkbox}
            onChange={(e) => {
              onAgreed();
            }}
            checked={isAgreed}
            ariaLabel="agreement-acknowledgement"
          />
          <Box className={classes.checkSideWord}>
            <Typography variant="body1">{content}</Typography>
          </Box>
        </Grid>
        {showError && (
          <Grid xs={12} md={8}>
            <Typography className={classes.errorText} variant="body1">
              {t('components->>Acknowledgement.AcknowledgementInstruction')}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
export default Acknowledgement;
